import React from 'react';

const Organizers = ({ organiserData = [] }) => {

    return (
        <div className="r_organizers">
            {organiserData.map((organizer, index) => (
                <div className="r_organizerMultiple" key={index}>
                    <div className="r_organizerName">{organizer.name}</div>
                    <div className="r_organizerDetailsMultiple">
                        <div className="r_organizerMultipleRow">
                            <div className="r_organizerColumnItem">
                                <div className="r_organizerColumnItemTitle">{playdetailsv2_resources.Address}</div>
                                <div className="r_organizerColumnItemContent">
                                    {organizer.address}, {organizer.city} {organizer.postalCode}
                                </div>
                            </div>
                            <div className="r_organizerColumnItem">
                                <div className="r_organizerColumnItemTitle">{playdetailsv2_resources.Tel}</div>
                                {(organizer.phone?.trim() && organizer.phone !== '-') ? (
                                    <a className="r_organizerColumnItemContent contentLink" href={`tel:${organizer.phone}`}>
                                        {organizer.phone}
                                    </a>
                                ) : (
                                    <div className="r_organizerColumnItemContent">-</div>
                                )}
                            </div>
                        </div>
                        <div className="r_organizerMultipleRow">
                            <div className="r_organizerColumnItem">
                                <div className="r_organizerColumnItemTitle">{playdetailsv2_resources.TaxId}</div>
                                <div className="r_organizerColumnItemContent">
                                    {organizer.fiscalCode || '-'}
                                </div>
                            </div>
                            <div className="r_organizerColumnItem">
                                <div className="r_organizerColumnItemTitle">{playdetailsv2_resources.TaxOffice}</div>
                                <div className="r_organizerColumnItemContent">
                                    {organizer.fiscalOffice || '-'}
                                </div>
                            </div>
                        </div>
                        <div className="r_organizerMultipleRow">
                            <div className="r_organizerColumnItem">
                                <div className="r_organizerColumnItemTitle">{playdetailsv2_resources.Email}</div>
                                {(organizer.email?.trim() && organizer.email !== '-') ? (
                                    <a className="r_organizerColumnItemContent contentLink" href={`mailto:${organizer.email}`}>
                                        {organizer.email}
                                    </a>
                                ) : (
                                    <div className="r_organizerColumnItemContent">-</div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Organizers;